import AddRoundedIcon from '@mui/icons-material/AddRounded';
import Error from '@mui/icons-material/Error';
import { Alert, AlertColor, Box, Button, Paper, Stack } from '@mui/material';
import { useState } from 'react';

import { Piece, PieceAction, PieceAnnotation, Workflow } from '@apiContract';
import Title from '@components/DrawerContent/Title';

import { getBarcodesStatusesCounts, getTrackingNumberAnnotations } from '@utils/annotations';

import TrackForm from './components/TrackForm';
import TrackInput from './components/TrackInput';
import { sxPaper } from './styles';
import { getGlobalAlert } from './utils';

type BarcodeProps = {
  onClose: () => void;
  piece?: Piece;
  pieceAnnotations: PieceAnnotation[] | null;
  workflow: Workflow;
  onCreate?: (piceAnnotation: PieceAnnotation) => void;
  noAddButton?: boolean;
  detected?: boolean;
};

const Barcode = ({ onClose, piece, pieceAnnotations, workflow, onCreate, noAddButton, detected }: BarcodeProps) => {
  const [open, setOpen] = useState(false);

  const isLoading = !detected && !piece?.events.some((event) => event.action === PieceAction.BarcodeDetectionComplete);

  const filteredAnnotations = getTrackingNumberAnnotations(pieceAnnotations);
  const hasRecipient = !!piece?.recipient;

  const alert = getGlobalAlert(filteredAnnotations);
  const barcodeStatuses = getBarcodesStatusesCounts(filteredAnnotations);

  return (
    <Paper sx={sxPaper}>
      <Title title="Tracking Numbers" onClose={onClose} isLoading={isLoading} />
      <Stack spacing={3} p={3}>
        {!isLoading && alert && (
          <Alert icon={alert.severity === 'error' ? <Error /> : undefined} severity={alert.severity as AlertColor}>
            {alert.text}
          </Alert>
        )}
        {filteredAnnotations.map((item) => (
          <TrackInput
            barcodeStatuses={barcodeStatuses}
            key={item.id}
            item={item}
            workflow={workflow}
            hasRecipient={hasRecipient}
          />
        ))}

        {!noAddButton && (
          <Box display="flex" justifyContent="flex-start">
            <Button variant="text" startIcon={<AddRoundedIcon />} onClick={() => setOpen((prev) => !prev)}>
              Add Tracking Number
            </Button>
          </Box>
        )}
        {open && piece && <TrackForm pieceId={piece.id} onClose={() => setOpen(false)} onCreate={onCreate} />}
      </Stack>
    </Paper>
  );
};

export default Barcode;
